import { useEffect, useState } from "react";
import API from "../../../services/API";
import Table from "../../Account/components/Affiliates";
import { Stack, Typography } from "@mui/material";

export default function Affiliates({person}){

    const [data, setData] = useState([]);

    useEffect(() => {

        API.get(`/users/${person.id}/affiliates`)
            .then(r => setData(r.data))

    }, [person])

    return data.length > 0 && <Stack spacing={2}>

        <Typography variant='h3'>Filleuls</Typography>
        
        <Table items={data} />

    </Stack>
}